// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sjndvgfvfpveoxcgaylk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNqbmR2Z2Z2ZnB2ZW94Y2dheWxrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA5MDE1NTAsImV4cCI6MjA2NjQ3NzU1MH0.nF2mEwmL8JM2C7a8gwA5Gu-Jow9zVK8TA7nMerjHwuM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);